<template>
  <div class="mall-page" :style="bannerFlag ? 'margin-top: 45px;' : ''">

    <!-- 主体面板：筛选导航栏 + 商品列表 -->
    <div class="container w">
      <!-- 筛选导航栏 -->
      <div class="nav-inner">
        <div class="nav-tabs">
          <a href="javascript:void(0)" v-for="(val,i) in category" :key="i" @click="clickSort(i,val)" :class="{active: sortType === i}">{{val}}</a>
        </div>
        <div class="nav-search">
          <el-input size="small" placeholder="搜索商品" prefix-icon="el-icon-search" v-model="searchKey" @keyup.enter.native="loadMallGoods">
          </el-input>
          <y-button text="搜索" classStyle="main-btn" @btnClick="loadMallGoods"></y-button>
        </div>
      </div>

      <div v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(255,255,255,0.8)"
        style="min-height: 55vh;">

        <div class="goods-item" v-if="goodsList.length > 0">
          <div class="goods-box">
            <mall-goods v-for="(item,i) in goodsList" :key="i" :msg="item" @openDialog="openDialog"></mall-goods>
          </div>
          <!-- 瀑布流加载状态提示（替代传统分页器） -->
          <div class="load-more-tip" v-if="!error">
            <span v-if="loadingMore"><i class="el-icon-loading"></i> 正在加载更多商品...</span>
            <span v-else-if="noMore">— 已加载全部商品 —</span>
            <span v-else>向下滚动加载更多</span>
          </div>
        </div>

        <div class="no-info" v-if="noGoods">
          <div class="no-data">
            <img src="/static/images/no-search.png">
            <p>抱歉！暂时还没有商品</p>
          </div>

          <section class="section">
            <y-shelf :title="recommendPanel.name">
              <div slot="content" class="recommend">
                <mall-goods :msg="item" v-for="(item,i) in recommendPanel.panelContents" :key="i"></mall-goods>
              </div>
            </y-shelf>
          </section>
        </div>

        <div class="no-info" v-if="error">
          <div class="no-data">
            <img src="/static/images/error.png">
            <p>抱歉！出错了...</p>
          </div>

          <section class="section">
            <y-shelf :title="recommendPanel.name">
              <div slot="content" class="recommend">
                <mall-goods :msg="item" v-for="(item,i) in recommendPanel.panelContents" :key="i"></mall-goods>
              </div>
            </y-shelf>
          </section>
        </div>

      </div>
    </div>

    <el-dialog
      title="提示"
      :visible.sync="dialogFlag"
      width="30%"
      center>
      <p style="text-align: center;">
        <img src="/static/qr/qrcode.jpg"/>
        <br>
        <span>扫码进入<span style="color: #1890ff;">医小智Mall</span>小程序下单</span>
      </p>
    </el-dialog>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  // import list1 from "/assets/config/mall.js";
  import mallGoods from '/components/mallGoods'
  import YButton from '/components/YButton'
  import YShelf from '/components/YShelf'
  export default {
    data() {
      return {
        bannerFlag: false,
        loading: true,
        loadingMore: false,
        noMore: false,
        error: false,
        noGoods: false,
        goodsList: [],
        goodsList2: [],
        searchKey: '',
        sortType: -1,
        recommendPanel: [],
        total: 0,
        params: {
        	search: '',
        	sort: 'weigh',
        	order: 'asc',
          pageNum: 1,
          pageSize: 12,
        	filter: {},
        	op: {}
        },
        dialogFlag: false,
        category:[]
      }
    },
    computed: {
      ...mapState(['user']),
    },
    methods: {
      // 控制顶部
      navFixed() {
        if (this.$route.path === '/mall') {
          var st = document.documentElement.scrollTop || document.body.scrollTop
          st >= 60 ? this.bannerFlag = true : this.bannerFlag = false
        } else {
          return
        }
      },
      // 滚动监听：吸顶控制 + 触底触发瀑布流加载（京东式分页）
      handleScroll() {
        this.navFixed()
        this.checkLoadMore()
      },
      // 检测是否滚动至底部附近，触发加载下一页
      checkLoadMore() {
        if (this.loading || this.loadingMore || this.noMore || this.error) return
        if (this.goodsList.length === 0 || this.goodsList.length >= this.total) return
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        const clientHeight = document.documentElement.clientHeight
        const scrollHeight = document.documentElement.scrollHeight
        // 距底部 200px 时提前预加载，体验更顺滑
        if (scrollTop + clientHeight >= scrollHeight - 200) {
          this.loadMoreGoods()
        }
      },
      // 加载下一页并追加到列表尾部（瀑布流分页）
      loadMoreGoods() {
        this.loadingMore = true
        this.params.pageNum += 1
        this.$api.get({
          url: '/biz/mall/item/list',
          data: this.params
        }).then(res => {
          const list = res.rows || []
          this.goodsList = this.goodsList.concat(list)
          this.goodsList2 = this.goodsList
          this.total = res.total !== undefined ? res.total : this.total
          if (list.length === 0 || this.goodsList.length >= this.total) {
            this.noMore = true
          }
          this.loadingMore = false
        }).catch(() => {
          this.params.pageNum -= 1
          this.loadingMore = false
        })
      },
      // 价格排序
      clickSort(v,val) {
        this.sortType = v
        this.params.pageNum = 1
        let temp = []
        if(this.goodsList != this.goodsList2){
          this.goodsList = this.goodsList2
        }
        this.goodsList.forEach(item=>{
          if(val == item.category.name){
            temp.push(item)
          }
        })
        this.goodsList = temp
        this.loadMallGoods()
      },
      loadMallGoods() {
        this.loading = true
        this.params.pageNum = 1
        this.noMore = false
        this.params.search = this.searchKey
        this.$api.get({
          url:'/biz/mall/item/list',
          data: this.params
        }).then(res=>{
          this.goodsList = res.rows || [];
          this.goodsList2 = this.goodsList;
          console.log('this.goodsList: ',this.goodsList);
          this.noGoods =  res.total > 0 ? false : true
          this.total = res.total || 0;
          this.noMore = this.goodsList.length >= this.total
          this.error = false
          this.loading = false
        }).catch(() => {
          this.error = true
          this.loading = false
        })
        this.params.search = ''
      },
      openDialog(open){
        this.dialogFlag = open
      }
    },
    created() {
      // if(this.user.userType === '99'){
      //   this.$store.commit('common/recordNav',{navIndex: 3,navSubIndex: 0})
      // }else{
      //   this.$store.commit('common/recordNav',{navIndex: 4,navSubIndex: 0})
      // }
      this.loadMallGoods();
    },
    mounted() {
      this.navFixed()
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.handleScroll)
      document.title = "医小智 - 在线商城"
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
      window.removeEventListener('resize', this.handleScroll)
    },
    components: {
      mallGoods,
      YButton,
      YShelf
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../../assets/style/mixin";
  @import "../../assets/style/theme";

  .mall-page {
    min-height: 100vh;
    padding-bottom: 60px;
    background: #f6f7f9;
  }

  // 筛选导航栏 - 位于白色面板内部，底部细线分隔商品列表。
  .nav-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 0 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;
    overflow: hidden;
  }

  .nav-tabs {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;

    a {
      padding: 6px 18px;
      font-size: 14px;
      color: #666;
      border-radius: 20px;
      transition: all 0.3s ease;
      text-decoration: none;

      &:hover {
        color: #1890ff;
        background: rgba(24, 144, 255, 0.06);
      }

      &.active {
        color: #fff;
        background: #1890ff;
        box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
      }
    }
  }

  .nav-search {
    display: flex;
    align-items: center;
    gap: 10px;

    /deep/ .el-input {
      width: 220px;

      .el-input__inner {
        border-radius: 20px;
        border: 1px solid #e8e8e8;
        height: 36px;
        line-height: 36px;
        background: #f7f8fa;

        &:focus {
          border-color: #1890ff;
          background: #fff;
        }
      }
    }
  }

  // 主体面板 - 白色背景承载筛选栏与商品列表，与浅灰页面背景形成层次对比。
  .container {
    margin-top: 16px;
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    overflow: hidden;
  }

  .goods-item {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .goods-box {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    width: 100%;

    > div {
      min-width: 0;
    }
  }

  // 瀑布流加载状态提示（替代传统分页器）
  .load-more-tip {
    width: 100%;
    text-align: center;
    margin: 36px 0 16px;
    font-size: 14px;
    color: #999;
    letter-spacing: 1px;

    i {
      margin-right: 6px;
      color: #1890ff;
    }
  }

  // 空状态 / 错误状态 - 简洁卡片化呈现，弱化图标、文字颜色更柔和。
  .no-info {
    padding: 80px 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;

    .no-data {
      img {
        width: 160px;
        opacity: 0.8;
      }

      p {
        margin-top: 16px;
        font-size: 16px;
        color: #999;
      }
    }
  }

  .section {
    padding-top: 40px;
    width: 100%;
  }

  .recommend {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?939d23ec